import { Geometry } from '@turf/turf';
import { ActivityPoint } from './vehicle-activity-point';
import { VehicleActivityType } from './vehicle-activity-type';

import * as turf from '@turf/turf';
import * as _ from 'lodash';


export class VehicleActivity {
    trafficDate: Date;
    inventoryNumber: string;
    vehicleActivityId: string;
    activityPoints: ActivityPoint[];
    type: VehicleActivityType;
    startTime: string;
    endTime: string;

    tripNumber?: string;
    tripDescription?: string;
    routeName?: string;
    routePublicName?: string;

    pathAlternativGeoJson?: string;
    pathGeoJson?: string;

    shapeGeometry: Geometry;
    alternativShapeGeometry: Geometry;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (!this.pathGeoJson && obj?.geoJson) {
            this.pathGeoJson = obj.geoJson;
        }

        if (this.pathGeoJson) {
            try {
                this.shapeGeometry = JSON.parse(this.pathGeoJson);
            } catch (error) {
                console.log(`could not parse geoJson JSON for vehicleActivity: ${this.vehicleActivityId}`);
                this.pathGeoJson = undefined;
            }
        }

        if (this.pathAlternativGeoJson) {
            try {
                this.alternativShapeGeometry = JSON.parse(this.pathAlternativGeoJson);
            } catch (error) {
                console.log(`could not parse geoJson JSON for vehicleActivity: ${this.vehicleActivityId}`);
                this.pathAlternativGeoJson = undefined;
            }
        }

        if (this.activityPoints) {
            this.activityPoints = _.map(this.activityPoints, ap => new ActivityPoint(ap));
        }
    }

    public toFeature() {
        if (!this.shapeGeometry) {
            return undefined;
        }

        const properties = {
            zIndex: 10,
            type: 'shape'
        };

        const feature = turf.feature(this.shapeGeometry, properties);
        return feature;
    }
}
